import React, { useState, useEffect, useContext } from 'react';
import { Search, SortAsc, X } from 'lucide-react';
import Select from 'react-select';
import AuthContext from "../contexts/auth-context";
import { getUserTeam } from "../util.js";
import { useNavigate } from "react-router-dom";
import RefreshStatus from "./RefreshStatus";

const LocationsHeader = ({ onSearch, onSort, refreshStatus }) => {
    const authCtx = useContext(AuthContext);
    const [searchTerm, setSearchTerm] = useState('');
    const navigate = useNavigate();

    const sortOptions = [
        { value: 'name-asc', label: 'Name (A-Z)', option: 'name', direction: 'asc' },
        { value: 'name-desc', label: 'Name (Z-A)', option: 'name', direction: 'desc' },
        { value: 'occupancy-asc', label: 'Occupancy (Low to High)', option: 'occupancy', direction: 'asc' },
        { value: 'occupancy-desc', label: 'Occupancy (High to Low)', option: 'occupancy', direction: 'desc' }
    ];

    const [currentSort, setCurrentSort] = useState(sortOptions[0]);

    const handleClearSearch = () => {
        setSearchTerm('');
        onSearch('');
    };

    const handleSearch = (e) => {
        const value = e.target.value;
        setSearchTerm(value);
        onSearch(value);
    };

    const handleSort = (selectedOption) => {
        setCurrentSort(selectedOption);
        const [option, direction] = selectedOption.value.split('-');
        onSort(option, direction);
    };

    const customStyles = {
        control: (provided) => ({
            ...provided,
            height: '48px',
            minWidth: '250px',
            backgroundColor: '#edf3f8',
            border: '1px solid #e2e8f0',
            borderRadius: '10px',
            boxShadow: 'none',
            '&:hover': {
                border: '1px solid #e2e8f0'
            }
        }),
        menu: (provided) => ({
            ...provided,
            borderRadius: '10px',
            marginTop: '4px',
            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)'
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected ? '#edf3f8' : 'white',
            color: 'black',
            '&:hover': {
                backgroundColor: '#f7fafc'
            }
        }),
        singleValue: (provided) => ({
            ...provided,
            color: 'black'
        }),
        dropdownIndicator: (provided) => ({
            ...provided,
            color: '#9ca3af'
        }),
        indicatorSeparator: () => ({
            display: 'none'
        })
    };

    return (
        <div className="locations-header" style={{
            display: 'flex',
            alignItems: 'center',
            width: '100%',
            padding: '0.75rem',
            boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)'
        }}>
            <div style={{
                display: 'flex',
                alignItems: 'center'
            }}>
                <img
                    src={getUserTeam(authCtx.league, authCtx.venue).imgURL} 
                    alt="logo"
                    style={{
                        height: '50px',
                        marginRight: '24px',
                        marginLeft: '16px',
                        objectFit: 'contain'
                    }}
                />

                <l-bouncy-arc></l-bouncy-arc>
                <l-ring
                    size={50}
                    stroke="5"
                    bg-opacity="0"
                    speed="2"
                    color="green"
                ></l-ring>

                <div style={{ position: 'relative' }}>
                    <input
                        type="text"
                        placeholder="Search"
                        value={searchTerm}
                        onChange={handleSearch}
                        style={{
                            width: '400px',
                            height: '50px',
                            backgroundColor: '#edf3f8',
                            paddingLeft: '2.75rem',
                            paddingRight: searchTerm ? '2.75rem' : '1rem',
                            border: '1px solid #e2e8f0',
                            borderRadius: '12px',
                            fontSize: '1rem',
                            outline: 'none'
                        }}
                    />
                    <div style={{
                        position: 'absolute',
                        left: '1rem',
                        top: '50%',
                        transform: 'translateY(-50%)'
                    }}>
                        <Search color="#9ca3af" size={20} />
                    </div>
                    {searchTerm && (
                        <button
                            onClick={handleClearSearch}
                            style={{
                                position: 'absolute',
                                right: '1rem',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                background: 'none',
                                border: 'none',
                                padding: '0',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        >
                            <X color="#9ca3af" size={20} />
                        </button>
                    )}
                </div>
            </div>

            <div style={{ flex: 1 }} />

            {/* When the cards last updated and when they update next */}
            {refreshStatus && (
                <div style={{ marginRight: '1rem' }}>
                    <RefreshStatus {...refreshStatus} />
                </div>
            )}

            <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '0.75rem'
            }}>
                <SortAsc color="#9ca3af" size={24} />
                <Select
                    value={currentSort}
                    onChange={handleSort}
                    options={sortOptions}
                    styles={customStyles}
                    isSearchable={false}
                    menuPlacement="bottom"
                />
            </div>
        </div>
    );
};

export default LocationsHeader;